let modalCount = 0;
let originalBodyOverflow = '';
let originalHtmlOverflow = '';
let originalBodyPaddingRight = '';
let scrollbarWidth = 0;

export const lockBodyScroll = () => {
    modalCount++;
    if (modalCount === 1) {
        // Вычисляем ширину скроллбара до блокировки
        scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        
        // Сохраняем оригинальные значения
        originalBodyOverflow = window.getComputedStyle(document.body).overflow;
        originalHtmlOverflow = window.getComputedStyle(document.documentElement).overflow;
        originalBodyPaddingRight = window.getComputedStyle(document.body).paddingRight;
        
        // Блокируем скролл на html и body с высоким приоритетом
        document.documentElement.style.setProperty('overflow', 'hidden', 'important');
        document.body.style.setProperty('overflow', 'hidden', 'important');
        document.body.style.setProperty('position', 'fixed', 'important');
        document.body.style.setProperty('width', '100%', 'important');
        document.body.style.setProperty('top', `-${window.scrollY}px`, 'important');
        
        // Компенсируем ширину скроллбара, чтобы избежать смещения контента
        if (scrollbarWidth > 0) {
            document.body.style.setProperty('padding-right', `${scrollbarWidth}px`, 'important');
        }
    }
    
    return () => {
        modalCount = Math.max(0, modalCount - 1);
        if (modalCount === 0) {
            // Восстанавливаем оригинальные значения
            const scrollY = document.body.style.top;
            document.documentElement.style.removeProperty('overflow');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('position');
            document.body.style.removeProperty('width');
            document.body.style.removeProperty('top');
            document.body.style.removeProperty('padding-right');
            
            // Восстанавливаем позицию скролла
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        }
    };
};
